import React from 'react';

import { CapaQuotationChatMessage } from '@generated/graphql';

import { formatMessageTimeStamp } from '@utils/formatter';

import { CustomizedTypography } from '@components/Customized';
import { clsx } from '@components/Provider';

import useStyles from './useStyles';
import { useSelector } from '@store';

interface Props {
  isOwner: boolean;
  message?: CapaQuotationChatMessage;
}

const ChatMessageBubbleAdormentPresenter: React.FC<Props> = ({
  isOwner,
  message
}) => {
  const classes = useStyles();

  const messageCreatedAt = message?.createdAt
    ? new Date(message?.createdAt)
    : undefined;

  const partnerLastSeenAt =
    useSelector((state) => state.chat.partnerLastSeenAt) ?? undefined;

  const readAt = partnerLastSeenAt
    ? new Date(new Date(partnerLastSeenAt).setMilliseconds(0))
    : undefined;

  const readAtTimeStamp = +(readAt?.getTime() ?? 0);

  const messageCreatedAtTimeStamp = +new Date(
    new Date(messageCreatedAt!).setMilliseconds(0)
  ).getTime();

  const isUnread =
    message?.unReadCount !== 0
      ? readAt
        ? readAtTimeStamp - messageCreatedAtTimeStamp >= 0
          ? 0
          : 1
        : 1
      : 0;

  return (
    <div
      className={clsx(classes['Chat-Message-Bubble-Adorment'], {
        owner: isOwner
      })}
    >
      {isUnread && isOwner ? (
        <CustomizedTypography variant="caption" color="primary">
          1
        </CustomizedTypography>
      ) : null}
      <CustomizedTypography variant="caption" color="textSecondary">
        {messageCreatedAt
          ? formatMessageTimeStamp(messageCreatedAt.toString())
          : ''}
      </CustomizedTypography>
    </div>
  );
};

export default ChatMessageBubbleAdormentPresenter;
